import { actions } from 'react/api/actions/alerts';
import { fromJS } from 'immutable';

const INITIAL_ALERT_STATE = fromJS({
  title: '',
  description: '',
  isOpen: false,
  data: {}
});

const initialState = fromJS({
  trackEquipmentCoords: INITIAL_ALERT_STATE,
  routeDetailsCoords: INITIAL_ALERT_STATE
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.openAlert: {
      const {
        key, title, description, data = {}
      } = action.payload;

      return state.setIn([key], fromJS({
        isOpen: true,
        data,
        title,
        description
      }));
    }
    case actions.closeAlert: {
      const { key } = action.payload;

      return state.setIn([key], INITIAL_ALERT_STATE);
    }
    default:
      return state;
  }
};
